import { connect } from 'react-redux';
import AppModal from './AppModal';
import { closeModal, openModal } from './modalActions';
import { setLoginStatus } from '../login/LogInActions';

function mapStateToProps(state) {
  return {
    isOpen: state.modal.isOpen,
    resetPasswordStep: state.resetPassword.step,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onCloseModal: () => dispatch(closeModal()),
    openModal: e => dispatch(openModal(e)),
    setLoginStatus: isLoggedIn => dispatch(setLoginStatus(isLoggedIn)),
  };
}


const AppModalContainer = connect(mapStateToProps, mapDispatchToProps)(AppModal);
export default AppModalContainer;
